import { faStar as star } from '@fortawesome/free-regular-svg-icons';
import { faStar as solidStar } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

import { FavoriteIcon } from './TrlFavoriteIcon.styles';

export const TrlFavoriteIcon = ({ isDisabled, isFavorite, onClick }) => (
  <FavoriteIcon
    disabled={isDisabled}
    icon={isFavorite ? solidStar : star}
    onClick={() => {
      if (!isDisabled) onClick();
    }}
  />
);

TrlFavoriteIcon.propTypes = {
  isDisabled: PropTypes.bool,
  isFavorite: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
